export default "__VITE_ASSET__ZS9w5PbQ__"